import vert from './glsl/powerlines.vert.glsl';
import frag from './glsl/powerlines.frag.glsl';
export default { frag, vert };